import { render, staticRenderFns } from "./createMyTopic.vue?vue&type=template&id=7bbdf87b"
import script from "./createMyTopic.vue?vue&type=script&lang=js"
export * from "./createMyTopic.vue?vue&type=script&lang=js"
import style0 from "./createMyTopic.vue?vue&type=style&index=0&id=7bbdf87b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports